<template>
  <!--两客一危一重客户参数-->
  <div>
    <Row>
      中心账号(打包台账包含客户账号)
    </Row>
    <Row>
      <Select v-model="selectYeHu" style="width:300px; margin-right: 10px;">
        <Option v-for="item in yeHuList" :value="item.id" :key="item.name">{{ item.name }}</Option>
      </Select>
      <DatePicker style="display: inline-block; width: 200px; margin-right: 10px;" type="date" v-model="selectDatetime"
                  placeholder="选择日期"></DatePicker>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onExportClick">导出</Button>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onPackClick">打包台账</Button>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onDownloadZipClick">下载打包台账</Button>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onMakeDangerousFileClick">生成危化车夜间行驶报表</Button>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onDownloadDangerousFileClick">下载危化车夜间行驶报表</Button>
    </Row>
    <Row>
      客户账号
    </Row>
    <Row>
      <Select v-model="selectClientYeHu" style="width:300px; margin-right: 10px;">
        <Option v-for="item in clientYeHuList" :value="item.id" :key="item.name">{{ item.name }}</Option>
      </Select>
      <Select v-model="selectTemplateType" style="width:300px; margin-right: 10px;">
        <Option v-for="item in templateTypes" :value="item.val" :key="item.label">{{ item.label }}</Option>
      </Select>
      <DatePicker style="display: inline-block; width: 200px; margin-right: 10px;" type="date" v-model="selectClientDatetime"
                  placeholder="选择日期"></DatePicker>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onClientExportClick">导出</Button>
    </Row>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import { mapActions } from 'vuex'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { numberFormat } from '@/libs/numberutil'

  export default {
    name: "gpsstandingbooks",
    components:{

    },
    data(){
      return{
        clientYeHuList:[],
        selectClientYeHu:null,
        selectClientDatetime:new Date(),

        selectTemplateType:1,
        templateTypes:[{label:'中山', val:1},
          {label:'江门', val:2}
        ],

        yeHuList:[],
        selectYeHu:null,
        selectDatetime:new Date()
      }
    },
    methods:{
      onPackClick(){
        if (!this.selectDatetime) {
          this.$Message.error('未选择日期')
          return
        }
        let sDatetime = this.selectDatetime.Format('yyyy-MM-dd 00:00:00')
        store.dispatch('GpsStandingBookServ_MakePackage', {
          params: {selectDatetime:sDatetime},
          urlparams: null
        }).then(() => {
          this.$Message.success('开始打包');
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      onMakeDangerousFileClick(){
        if (!this.selectDatetime) {
          this.$Message.error('未选择日期')
          return
        }
        let sDatetime = this.selectDatetime.Format('yyyy-MM-dd 00:00:00')
        store.dispatch('GpsStandingBookServ_MakeDangerousFile', {
          params: {selectDatetime:sDatetime},
          urlparams: null
        }).then(() => {
          this.$Message.success('开始生成');
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      onDownloadDangerousFileClick(){
        if (!this.selectDatetime) {
          this.$Message.error('未选择日期')
          return
        }
        let sDatetime = this.selectDatetime.Format('yyyy-MM-dd 00:00:00')
        let url = '/api/gdviss/gpsstandingbook/downloaddangerousfile?selectDatetime=' + sDatetime
        window.location.href = url
      },
      onDownloadZipClick(){
        if (!this.selectDatetime) {
          this.$Message.error('未选择日期')
          return
        }
        let sDatetime = this.selectDatetime.Format('yyyy-MM-dd 00:00:00')
        let url = '/api/gdviss/gpsstandingbook/downloadpackage?selectDatetime=' + sDatetime
        window.location.href = url
      },
      onClientExportClick(){
        console.log(this.selectClientYeHu)
        let syh = null;

        for(let i = 0;i < this.clientYeHuList.length; i++){
          if(this.clientYeHuList[i].id == this.selectClientYeHu){
            syh = this.clientYeHuList[i];
            break;
          }
        }
        console.log(syh)
        if (!this.selectClientDatetime) {
          this.$Message.error('未选择日期')
          return
        }
        let sDatetime = this.selectClientDatetime.Format('yyyy-MM-dd 00:00:00')
        let url = '/api/gdviss/gpsstandingbook/clientexportexcel?yeHuName=' + syh.name + '&templateType=' + this.selectTemplateType + '&pid=' + syh.id + '&selectDatetime=' + sDatetime
        window.location.href = url
      },
      onExportClick(){
        console.log(this.selectYeHu)
        let syh = null;

        for(let i = 0;i < this.yeHuList.length; i++){
          if(this.yeHuList[i].id == this.selectYeHu){
            syh = this.yeHuList[i];
            break;
          }
        }
        console.log(syh)
        if (!this.selectDatetime) {
          this.$Message.error('未选择日期')
          return
        }
        let sDatetime = this.selectDatetime.Format('yyyy-MM-dd 00:00:00')
        let url = '/api/gdviss/gpsstandingbook/exportexcel?yeHuName=' + syh.name + '&pid=' + syh.id + '&selectDatetime=' + sDatetime
        window.location.href = url
      }
    },
    mounted () {
      this.$nextTick(() => {
        store.dispatch('GpsStandingBookServ_GetYeHuList', {
          params: null,
          urlparams: null
        }).then(() => {
          this.yeHuList = store.getters.get_GpsStandingBook_GetYeHuListResult
        }).catch(err => {
          this.$Message.error(err)
        })

        store.dispatch('GpsStandingBookServ_GetClientYeHuList', {
          params: null,
          urlparams: null
        }).then(() => {
          this.clientYeHuList = store.getters.get_GpsStandingBook_GetClientYeHuListResult
        }).catch(err => {
          this.$Message.error(err)
        })
      })
    },
    destroyed() {

    }
  }
</script>

<style scoped>

</style>
